import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-[#fffdfb] min-h-screen">
      {/* HEADER */}
      <div className="bg-gradient-to-r from-violet-700 to-purple-500 py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl font-bold text-white">
            Privacy Policy
          </h1>

          <p className="text-white/90 text-lg mt-4">
            Last updated: 02/06/2026
          </p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="bg-white rounded-[30px] shadow-xl p-10 space-y-10">

          <p className="text-gray-700 text-lg leading-relaxed">
            At FrendRops, we value your privacy and are committed to protecting
            your personal information. This Privacy Policy explains how we
            collect, use, store, and safeguard your information when you use
            our website, mobile application, and services.
          </p>

          {/* 1 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              1. Information We Collect
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We may collect personal details such as your full name, email
              address, mobile number, delivery address, billing address, and
              payment information when you register, place an order, or contact
              us.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We may also collect device information including browser type,
              operating system, IP address, cookies, and usage analytics to
              improve our services and user experience.
            </p>
          </div>

          {/* 2 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              2. How We Use Your Information
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Your information is used to process orders, manage deliveries,
              provide customer support, improve our platform, send updates,
              maintain account security, and comply with legal obligations.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We may also use your information to notify you about offers,
              promotions, discounts, and new services provided by FrendRops.
            </p>
          </div>

          {/* 3 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              3. Sharing of Information
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We do not sell your personal information to third parties.
              However, we may share limited information with trusted partners
              such as payment gateways, delivery providers, analytics services,
              hosting providers, and technical support partners to operate our
              business effectively.
            </p>
          </div>

          {/* 4 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              4. Cookies and Tracking Technologies
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops uses cookies and similar technologies to personalize
              your experience, remember your preferences, analyze website
              traffic, and improve functionality.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              You can disable cookies through your browser settings, although
              some features of the website may not function properly.
            </p>
          </div>

          {/* 5 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              5. Data Security
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We implement reasonable technical and organizational security
              measures to protect your personal data against unauthorized
              access, misuse, disclosure, alteration, or destruction.
            </p>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              While we strive to protect your information, no method of
              electronic transmission or storage is completely secure.
            </p>
          </div>

          {/* 6 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              6. User Accounts
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              You are responsible for maintaining the confidentiality of your
              account credentials and password. Please notify us immediately if
              you suspect unauthorized access to your account.
            </p>
          </div>

          {/* 7 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              7. Payment Information
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              All online payments are processed securely through trusted payment
              gateway providers such as Razorpay. FrendRops does not directly
              store your debit card, credit card, UPI PIN, or banking details.
            </p>
          </div>

          {/* 8 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              8. Third-Party Links
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              Our website may contain links to external websites or third-party
              services. We are not responsible for the privacy practices or
              content of such external platforms.
            </p>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              9. Your Rights
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              You have the right to access, update, modify, correct, or request
              deletion of your personal information. You may also opt out of
              promotional communications at any time.
            </p>
          </div>

          {/* 11 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              10. Changes to This Privacy Policy
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We reserve the right to update or modify this Privacy Policy at
              any time. Changes will become effective immediately upon posting
              on this page.
            </p>
          </div>

          {/* 12 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              11. Data Retention
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              We retain your personal information only for as long as necessary
              to provide our services, comply with legal obligations, resolve
              disputes, and enforce our agreements.
            </p>
          </div>

          {/* 13 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              12. Legal Compliance
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              FrendRops complies with applicable Indian laws relating to data
              protection, electronic transactions, and consumer rights.
            </p>
          </div>

          {/* 14 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              13. Contact Us
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              If you have any questions regarding this Privacy Policy or your
              personal information, please contact us:
            </p>

            <div className="mt-4 text-gray-700 text-lg space-y-2">
              <p><strong>FrendRops</strong></p>
              <p>Email: frendrops@gmail.com</p>
              <p>Website: https://www.frendrops.in</p>
              <p>Bengaluru, Karnataka, India</p>
            </div>
          </div>

          {/* 15 */}
          <div>
            <h2 className="text-3xl font-bold text-[#2d1457]">
              14. Consent
            </h2>

            <p className="text-gray-700 text-lg mt-4 leading-relaxed">
              By accessing or using FrendRops, you consent to the collection,
              storage, and use of your information as described in this Privacy
              Policy.
            </p>
          </div>

          {/* FOOTER BOX */}
          <div className="bg-violet-50 rounded-2xl p-6 border border-violet-100">
            <p className="text-[#2d1457] text-lg font-medium leading-relaxed">
              By using FrendRops services, website, or mobile application, you
              acknowledge that you have read and understood this Privacy Policy
              and agree to its terms.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
